<template>
  <div :class="['darker border-radius info-box', collapsedInfo ? 'collapsed-info' : '']">
    <div class="header clickable" @click="collapsedInfo = !collapsedInfo">
      <icon size="0.9" type="circle-question"/>
      HELP
      <icon v-if="collapsedInfo" class="float-right" type="angle-right"/>
      <icon v-else class="float-right" type="angle-down"/>
    </div>
    <div class="content">
      Filtering allows you to:
      <ul>
        <li>Remove all screws</li>
        <li>Remove the hull</li>
        <li>Remove all parts except the hull</li>
        <li>And much, much more</li>
      </ul>
      Try it out:
      <div class="settings-button d-inline-block mr-2" @click="$emit('removeAllSmallParts')">
        {{ $t('removeAllSmallParts') }}
      </div>
      <div class="settings-button d-inline-block mr-2" @click="$emit('removeAllSmallParts')">
        {{ $t('removeTheHull') }}
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";

export default {
  name: "FilterHelp",
  components: {Icon},
  data() {
    return {
      collapsedInfo: true,
    }
  },
}
</script>

<style scoped lang="scss">
.info-box {
  background-color: var(--vform-editor-ui-quinary-color);
  padding: 5px;
  .content {
    transition: all 300ms ease;
    height: 180px;
    padding: 15px;
  }

  &.collapsed-info {
    font-size: 0.8em;
    .content {
      height: 0;
      padding: 0;
      padding-left: 15px;
      opacity: 0;
      overflow: hidden;
    }
  }
}
</style>